import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[appTransitionPreventor]',
    standalone: true,
})
export class TransitionPreventorDirective {
  @HostBinding('class') elementClass: string;
  constructor() {
    this.elementClass = 'block-transitions';
    setTimeout(() => (this.elementClass = ''), 2);
  }
}
